import { JSONRPCClient } from 'src/apis/service';
import { ReportService } from 'src/apis/service/ReportService';
import { MessageThreadReportRequest, ReportProfileCardRequest } from 'src/types/report';
import { client } from 'src/utils/api';

export const ReportProfileCardAPI = async (body: ReportProfileCardRequest) =>
  client.post('/api/v1/reports/profile-card', body);

export const reportDMMessageThreadAPI = async (request: MessageThreadReportRequest) =>
  new ReportService(new JSONRPCClient()).reportMessageThread(request);
